import React from 'react';
import PropTypes from 'prop-types';
import ResponseDataHandleEmpty from './ResponseDataHandleEmpty.component';
import ResponseDataHandlePlaceholder from './ResponseDataHandlePlaceholder.component';
import ResponseDataHandleServerError from './ResponseDataHandleServerError.component';

const hasData = (data, dataKey) => {
  if (data && dataKey) return !!data[dataKey]?.length;

  if (data && Object.prototype.hasOwnProperty.call(data, 'total')) {
    return !!data.total;
  }

  return !!data;
};

const ResponseDataHandle = ({
  error,
  loading,
  data,
  iconType,
  dataKey,
  render,
  ...props
}) => {
  if (error) {
    return <ResponseDataHandleServerError {...props} />;
  }

  if (loading) {
    return <ResponseDataHandlePlaceholder {...props} />;
  }

  if (!hasData(data, dataKey)) {
    return <ResponseDataHandleEmpty iconType={iconType} {...props} />;
  }

  return render(data);
};

ResponseDataHandle.propTypes = {
  error: PropTypes.string,
  loading: PropTypes.bool,
  data: PropTypes.any,
  iconType: PropTypes.string,
  dataKey: PropTypes.string,
  render: PropTypes.any,
};

export default ResponseDataHandle;
